import storefrontApi from 'api/storefront-api'
import type { BrandDTO, BrandGroup, OldStoreProductFilterDTO } from 'ecosystem'
import { DynamicWidgetType } from 'ecosystem'
import type { StaticPath } from 'shared-utils'
import { groupByFirstLetter } from 'shared-utils'
import { brandFactory, dynamicPageWidgets } from 'api'
import { notFound } from 'next/navigation'

export const getStaticPropsHandler = async <T>(translations?: T) => {
  const store = await storefrontApi.store.getStore({ query: ['brands'] })
  if (!store.brands) {
    return notFound()
  }

  return {
    props: {
      ...translations,
      brands: groupByFirstLetter(store.brands) as BrandGroup[]
    }
  }
}

export const getStaticPropsDetailHandler = async <T>(
  slug: string,
  priceValues: {
    minPrice: number
    maxPrice: number
  },
  translations?: T
) => {
  const store = await storefrontApi.store.getStore({
    query: ['brands', 'deliveries']
  })
  const brand = brandFactory(slug, store.brands)

  if (!brand) {
    return notFound()
  }

  const filterOptionsResponse = await storefrontApi.store.getFilterOptions({
    brandIds: [brand.id],
    filters: [],
    ...priceValues
  })

  const widgets = await dynamicPageWidgets({ id: brand.id, type: 'brand' }, DynamicWidgetType.BRAND)

  const props = {
    ...translations,
    deliveryOptions: store.deliveries || null,
    brand,
    widgets,
    filterConfig: {
      options: filterOptionsResponse?.options || [],
      brands: [] //no need for a "brands" filter in the Brand page
    } as OldStoreProductFilterDTO
  }

  return {
    props
  }
}

export const getStaticPathsHandler = async () => {
  const store = await storefrontApi.store.getStore({ query: ['brands'] })
  const mapper = (brand: BrandDTO): StaticPath => ({ params: { slug: brand.slug.toString() } })
  const paths = store.brands
    ?.map(mapper)
    .flat()
    .filter((p) => p.params.slug !== '')
  return { paths: paths || [], fallback: 'blocking' }
}
